import './base.tailwind.generated.css';
import 'bz-core-controls/styles/colours.css';
import './main.css';
import './responsive.css';
import '@fontsource/inter';

import moment from 'moment';
import React from 'react';
import { createRoot } from 'react-dom/client';

import ReferralPortal from './App';
import reportWebVitals from './reportWebVitals';

createRoot(document.getElementById('root') as HTMLElement).render(<ReferralPortal />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/* eslint-disable no-extend-native */
Date.prototype.toJSON = function () {
  return moment(this).format('YYYY-MM-DDTHH:mm:ss');
};
/* eslint-enable no-extend-native */
